// in src/users.js
import React from 'react';
import {SimpleForm, Edit, TextInput, ReferenceArrayInput, SelectArrayInput, ChipField, required, Toolbar, DeleteButton} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import {HASH_TAG,  HASHTAG_RECOMMEND_LIST, HASHTAG_CATEGORY_LIST} from '../../consts/Names';
import {Validators, trimValidation} from '../../consts/Validators';
import {Messages} from '../../consts/Messages';
import { WithProps, SaveWithUpdateButton } from '../utils/RecordWrappers';

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },
   formContainer: {
      padding: '1em 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));
const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE), trimValidation];
const reWorkingRecord = (record) => {
   let newRecord = Object.assign({}, record);
   if(newRecord.tags)
   newRecord.tags = record.tags.map(el=> {return el.id});
   return newRecord;
}

const reworkedData = (props) => {
   props.ids = props.tags;
   delete props.tags;
   delete props[HASHTAG_CATEGORY_LIST.category_id];
   return Object.assign({}, props);
};

const EditToolbar = (props) => (
   <Toolbar {...props}  className={props.className}>
      <SaveWithUpdateButton replaceFunction={reworkedData} updatedSource={HASHTAG_RECOMMEND_LIST.SOURCE} redirect={`/${HASHTAG_RECOMMEND_LIST.SOURCE}/`}
      submitOnEnter={false} variant="text" />
      <DeleteButton  undoable={false}/>
   </Toolbar>
);


export const HashTagRecommendEdit = (props) => {
   const {theme} = props;
   const classes = useStyles(theme);

   return (
      <Edit {...props} title="Edit tags list for recommended"  undoable={false}>
         <WithProps callBackFunc={reWorkingRecord}>{({record,...props})=>
            <SimpleForm {...props} record={record} className={classes.formContainer} toolbar={<EditToolbar  className={classes.toolBar} {...props}/>} >
               <TextInput className={classes.textFld} label="List Name" source={HASHTAG_RECOMMEND_LIST.name} validate={validateStock} />
               <ReferenceArrayInput
                  className={classes.textFld}
                  label="Related tags"
                  reference={HASH_TAG.SOURCE}
                  source={'tags'}
                  perPage={1000}
                  validate={[required()]}>
                     <SelectArrayInput >
                           <ChipField source={HASH_TAG.name}/>
                     </SelectArrayInput>
                  </ReferenceArrayInput>
            </SimpleForm>
            }
         </WithProps>
      </Edit>
   );
};
